export default "__VITE_ASSET__CX_vQ4M4__"